import { StatusBarWidget } from './StatusBar';
import { Environment } from './environment';
import './jquery';
import { Service } from './service';
export class TermsAndConditionsWidget {
    private element: HTMLElement;
    private service: Service;
    private statusBarWidget: StatusBarWidget;
    private Validator: JQueryValidation.Validator;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;
        this.init();
    }
    init() {
        let th = this;
        $('[data-name=btnSubmitDenial]').on("click", (ev: Event) => th.submit(ev));
    }
    async submit(ev: Event) {
        let th = this;
        ev.preventDefault();      
        let url = $(ev.currentTarget).data("url");
        let redirectUrl = $(ev.currentTarget).data("returnurl");
        let formElement = $(th.element).find("#form");
        //unobtrusive
        formElement.validate();
        formElement.find("input").each((i, e) => {
            $(e).rules("add",
                {
                    required: true ,
                    messages: {
                        required: $(e).attr("errormessage")
                    }
                });
        })

        if (!formElement.valid()) {
            return false;
        }

        let data = formElement.serializeArray().map((x) => x.name);
        await this.service.PostObject({ 'request': data, 'returnUrl': redirectUrl }, null, url, this.statusBarWidget);
        window.location.href = redirectUrl; 
    }             
}